<div class="lang-list">
      <div class="item" (click)="_click('pt')">
            <img src="/images/icons/linguagem/pt.svg" width="30px" height="30px" loading="lazy" />
      </div>
      <div class="item" (click)="_click('en')">
            <img src="/images/icons/linguagem/en.svg" width="30px" height="30px" loading="lazy" />
      </div>
      <div class="item" (click)="_click('es')">
            <img src="/images/icons/linguagem/es.svg" width="30px" height="30px" loading="lazy" />
      </div>
</div>
